import { render, staticRenderFns } from "./SchedulingRecord.vue?vue&type=template&id=486d38ae&"
import script from "./SchedulingRecord.vue?vue&type=script&lang=js&"
export * from "./SchedulingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports